module.exports = __webpack_public_path__ + "img/check.b912f87c.svg";